import { render, staticRenderFns } from "./ExpiredPage.vue?vue&type=template&id=cbe8f7d2&"
import script from "./ExpiredPage.vue?vue&type=script&lang=js&"
export * from "./ExpiredPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports